import { useSelector } from 'react-redux';
import capitalize from '../../../utils/capitalize';
import { hideNumbers } from '../../../utils/hideNumbers';
import AvatarHeader from './AvatarHeader';
import {
  AvatarWrapper,
  HeaderUserName,
  UserInfoStack,
  UserInfoText,
  UserStack,
} from './StyledComponentHeader';

const HeaderUserInfo = ({ editable = false }) => {
  const { user } = useSelector(state => state.auth);

  const userRisk = user?.['custom:profile']?.toLowerCase() || '';
  const name = capitalize(user?.name || '');
  const lastName = capitalize(user?.['custom:paternal-surname'] || '');
  const email = user?.email || '';
  const dni = user?.['custom:dni'] || '';

  return (
    <UserStack>
      <AvatarWrapper>
        <AvatarHeader userRisk={userRisk} editable={editable} />
      </AvatarWrapper>
      <UserInfoStack>
        <HeaderUserName>{`${name} ${lastName}`}</HeaderUserName>
        <UserInfoText>{email}</UserInfoText>
        <UserInfoText>{hideNumbers(dni)}</UserInfoText>
      </UserInfoStack>
    </UserStack>
  );
};

export default HeaderUserInfo;
